import { render, staticRenderFns } from "./ViewTemplate.vue?vue&type=template&id=0c17d5b8&scoped=true"
import script from "./ViewTemplate.vue?vue&type=script&lang=js"
export * from "./ViewTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewTemplate.vue?vue&type=style&index=0&id=0c17d5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c17d5b8",
  null
  
)

export default component.exports